import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content before rendering with v-html.
 * Strips dangerous tags (<script>, event handlers, etc.) while preserving
 * safe formatting tags (<ul>, <li>, <p>, <img>, <b>, <i>, <a>...).
 */
export function sanitize(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html);
}
